export const onDialogClose = dialogType => ({
  widget: 'entries',
  type: 'onDialogClose',
  payload: { dialogType },
})



// WEBPACK FOOTER //
// ./src/entries/actions/onDialogClose.js